"use client";

import React, { useEffect } from "react";
import useSWR from "swr";
import { fetcher } from "@/lib/fetcher";
import useUserStore from "@/state/user/useUserStore";

const AssetsProvider = ({ children }: { children: React.ReactNode }) => {
  const [setAssetsCount] = useUserStore((state) => [state.setAssetsCount]);

  const { data } = useSWR("/api/assets", fetcher);

  useEffect(() => {
    setAssetsCount(data);
  }, [data]);

  return <>{children}</>;
};

export default AssetsProvider;
